import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";

const CheckEmailModal = ({ setOpen, open, email }) => {
  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogContent className="p-0 w-fit">
        <div className="border-[3px] border-secondary200 rounded-lg p-[1px] md:w-[400px]">
          <div className="w-full border-2 border-dashed border-[#71788450] rounded-lg p-6">
            <DialogHeader>
              <DialogTitle className="flex items-center">
                <span className="text-[20px] mr-2 text-black">
                  Check your mail
                </span>
              </DialogTitle>
              <DialogDescription className="py-4 flex flex-col text-[16px] text-left text-black max-w-[400px]">
                <span className="truncate">
                  We sent a link to <b className="truncate">{email}</b>.
                </span>
                <span>If you don't see it, check your spam folder.</span>
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <Button
                onClick={() => setOpen(false)}
                type="submit"
                className="px-4"
                // variant={"outlineDark"}
              >
                Close
              </Button>
            </DialogFooter>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CheckEmailModal;
